// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LO3d","label":"styles_label__312Dz"};